import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import { IQBRForm1554 } from 'partner360/models/qbr/IQBRForm1554'

export const getQbrDocumentsCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.JBPQBRDocument) as Crud<IQBRForm1554>
